import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/Logo.svg'


const _hoisted_1 = { class: "z-10 flex w-full justify-between bg-slate-900 px-8 py-6 md:w-auto md:justify-center md:bg-transparent" }
const _hoisted_2 = { class: "material-symbols-outlined align-center justify-self-center text-3xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-8 w-12 object-contain"
}, null, -1)
const _hoisted_4 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.navigationMDAnimationClass, _ctx.scrolledGreaterThanClass], "duration-400 relative z-10 flex w-full flex-col items-center justify-between text-nowrap bg-transparent drop-shadow-md transition md:fixed lg:flex-row"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
        class: _normalizeClass([_ctx.navigationMDAnimationClass, "animate-fade-down animate-once md:hidden"])
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentMenuIcon), 1)
      ], 2),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
        class: "flex w-56 animate-fade-down flex-row-reverse items-center justify-evenly text-lg animate-once md:flex-row"
      }, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.splitTitle[0]), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.splitTitle[1]), 1)
        ])
      ])
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass([_ctx.navigationAnimationClass, "absolute z-0 mt-20 flex h-auto w-full flex-col items-center justify-end divide-y bg-slate-900/60 py-6 transition-transform animate-once md:relative md:mt-0 md:w-auto md:translate-y-0 md:animate-fade-down md:flex-row md:space-x-8 md:divide-none md:border-none md:bg-transparent md:from-transparent lg:pr-16"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalPages, (page, key) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: key,
          class: _normalizeClass([_ctx.navItemClasses, _ctx.navItemAnimationClass, { [_ctx.activeClass]: _ctx.isActive(page.path) }]),
          to: page.path
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page.locale), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"]))
      }), 128)),
      _createVNode(_component_router_link, {
        class: _normalizeClass([_ctx.navItemClasses, _ctx.navItemAnimationClass, _ctx.endNavItemClass, { [_ctx.activeClass]: _ctx.isActive(_ctx.lastPage.path) }]),
        to: _ctx.lastPage.path
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.lastPage.locale), 1)
        ]),
        _: 1
      }, 8, ["class", "to"])
    ], 2)
  ], 2))
}